import { Fragment, useContext } from "react";
import { Outlet } from "react-router-dom";

import { ReactComponent as MetiLogo } from "../../assets/meti-box.svg";
import ProfileButton from "./profile-button/profile-button.component";
// import { BsClockHistory } from "react-icons/bs";

import useTranslate from "src/hooks/use-translate";

import { AuthContext } from "../../contexts/auth.context";

import "./topbar.style.scss";
import LanguageSelector from "./language-selector/language-selector.component";

import { S3Context } from "src/contexts/s3.context";

const Topbar = () => {
	const { user } = useContext(AuthContext);
	// const { readFromS3 } = useContext(S3Context);
	const t = useTranslate("Topbar");

	// const user = true;

	return (
		<Fragment>
			<div className={`topbar-container`}>
				<div className="left-side-container">
					{/* <div onClick={readFromS3} className="logo-container"> */}
					<div className="logo-container">
						<MetiLogo className="meti-logo" />
					</div>
					{/* {user && <div className="company-logo-container">My Company</div>} */}
				</div>
				<div className="right-side-container">
					{user ? (
						<Fragment>
							<ProfileButton title={t("Profile")} />
						</Fragment>
					) : (
						<LanguageSelector />
					)}
				</div>
			</div>
			<Outlet />
		</Fragment>
	);
};

export default Topbar;
